// lib/classTypes.js
// R9 수업 타입 표, R10 카디오·웨이트 포커스 표와 수업 추가·수정 폼 계산. 계약: docs/architecture/record-daily-design.md
//   0절(2026-10-12 사장님 결정) 7·9·10·11·12·13·16, 1.1·1.2
//   - 타입은 DB class_type_enum 값(ASCII) 그대로 서버와 주고받고 화면에는 표시명을 쓴다. 새 수업은 9개 타입만 고른다(11).
//     9번째 기타(other)는 2026-10-23 사장님 결정으로 표 끝에 더했다(migrations/015_class_type_other.sql, 서버 models.classTypeTable).
//     예전 타입(Hybrid·Core·Cardio)은 지난 수업·예약·기록에만 남고 표시명은 값 그대로다.
//   - 요일 제한이 없다(1.1). 어느 날짜에나 어느 타입이든 만든다. 수업 추가 창도 요일로 타입을 미리 고르지 않는다.
//   - 수업에는 타입만 남는다(12·13, 기타 수업은 이름도). 부위는 서버가 타입에서 정하고, 포커스(카디오·웨이트 두 칸, 16)는 운동 프로그램(daily_programs)에 들어간다.
//   - 예약이 있는 수업은 수정·삭제할 수 없고(9·10), 운동 기록이 있는 수업은 삭제할 수 없다(9). 서버는 기록 있는 수업의
//     수정도 거절한다(409 CLASS_HAS_WORKOUTS, 기록의 날짜·타입과 수업이 어긋나지 않게). 이 화면은 아는 만큼 미리 버튼을 끈다(classLock).
//   - 2026-10-24 사장님 결정: Hyrox·Running·기타 예약은 횟수권을 차감하지 않는다(A, isCreditFreeClassType). 기타 수업에는 관리자가
//     이름(classes.title, 회원 앱에 보이는 이름)을 붙인다(B, validateOtherClassTitle·classDisplayName). 둘 다 저장된 타입으로 본다.
//   - CAR-130(일요일 수업·휴무일): 수업관리 날짜 닫기 확인 창의 수업 줄(closeDateClassLines), 무료체험 신청 편집 창의 시간 선택지를
//     그 날짜의 실제 수업으로 만든다(classTimeOptions, 일요일 포함).
// 이 파일은 import가 없다(scripts/test-class-info.mjs가 node로 그대로 불러 시험한다).

const YMD_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const HHMM_RE = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/;

// 새 수업 타입 9개(사장님 결정 1.1 표 순서 + 끝에 기타). value = class_type_enum 값, label = 회원·관리자 화면 표시명(대소문자 그대로,
// 서버 models.ClassTypeLabel과 같은 글자), tone = 목록 색(hyb 초록 · core 주황 · car 빨강), icon = src/assets/icons/{icon}.png.
// 색·아이콘은 기존 3종 그림을 나눠 쓴다. 기타는 같은 정규 수업 밖 타입인 Hyrox와 같은 주황·core 모양이다(2026-10-23 사장님 결정 기본값)
export const CLASS_TYPES = [
  {
    value: "sprint_cardio",
    label: "Sprint & Cardio",
    tone: "car",
    icon: "cardio",
  },
  { value: "push_cardio", label: "Push & Cardio", tone: "car", icon: "cardio" },
  {
    value: "lower_cardio",
    label: "Lower body & Cardio",
    tone: "car",
    icon: "cardio",
  },
  { value: "pull_cardio", label: "Pull & Cardio", tone: "car", icon: "cardio" },
  {
    value: "full_cardio",
    label: "Full body & Cardio",
    tone: "car",
    icon: "cardio",
  },
  {
    value: "hybrid_cardio",
    label: "Hybrid cardio",
    tone: "hyb",
    icon: "hybrid",
  },
  { value: "hyrox", label: "Hyrox", tone: "core", icon: "core" },
  { value: "running", label: "Running", tone: "car", icon: "cardio" },
  { value: "other", label: "기타", tone: "core", icon: "core" },
];

// 예전 타입(지난 수업·기록에만). 표시명은 값 그대로
export const LEGACY_CLASS_TYPES = [
  { value: "Hybrid", label: "Hybrid", tone: "hyb", icon: "hybrid" },
  { value: "Core", label: "Core", tone: "core", icon: "core" },
  { value: "Cardio", label: "Cardio", tone: "car", icon: "cardio" },
];

// 카디오 포커스 표(사장님 결정 16, R10). value = cardio_focus_enum 값, 순서 = enum 순서 = 고르는 규칙 ①~⑤ = 선택지 순서.
// label은 서버 models.CardioFocusLabel(= dailysummary.CardioLabel)과 같은 글자다(회원 총평에 이 이름이 들어간다).
// hint는 관리자 선택지에만 쓰는 짧은 안내다(회원 문장의 쉬운 설명은 서버 dailysummary.CardioExplain이 정본).
// 운동 프로그램을 저장할 때 꼭 고른다(서버도 없으면 422, DECISIONS R10-1)
export const CARDIO_FOCUSES = [
  { value: "sprint", label: "스프린트", hint: "10~30초 전력 · 길게 쉼" },
  {
    value: "vo2max",
    label: "VO2max 인터벌",
    hint: "한 가지를 1~4분 강하게 · 정해진 휴식 반복",
  },
  {
    value: "threshold",
    label: "무산소 역치",
    hint: "쉬지 않고 6분 넘게 이어 감",
  },
  {
    value: "circuit",
    label: "고강도 서킷",
    hint: "스테이션을 Every N분 안에 · 남은 시간 쉼",
  },
  { value: "aerobic", label: "유산소 지구력", hint: "편하게 오래" },
];

// 카디오 포커스 고르는 규칙 안내(사장님 결정 16 문구). 운동 프로그램 탭의 카디오 포커스 칸 아래에 줄마다 <li>로 보인다
export const CARDIO_FOCUS_RULE = [
  "마지막 카디오(WOD)를 보고 위에서부터 처음 맞는 것을 고르세요.",
  "① 10~30초 전력, 길게 쉼 → 스프린트",
  "② 머신·달리기 한 가지를 1~4분 강하게, 정해진 휴식 반복 → VO2max 인터벌",
  "③ 쉬지 않고 6분 넘게 이어 감(Time Cap·AMRAP·팀 릴레이) → 무산소 역치",
  "④ 머신과 동작이 섞인 스테이션을 Every N분 안에서 하고 남은 시간 쉼 → 고강도 서킷",
  "⑤ 편하게 오래 → 유산소 지구력",
  "팀 교대는 방식이지 포커스가 아니에요. 이어 가는 릴레이는 무산소 역치, Every N분 안의 교대는 고강도 서킷이에요.",
  // 앱 전체 리뷰 1차: 간결 총평(판 5)은 수업 타입으로 출력 문장을 쓰지 않아 "출력은 … 총평이 말해요"를 뺐다(DECISIONS 결정 기록)
  "월요일 출력 구간은 따로 고르지 않아요.",
];

// 웨이트 포커스 표(class_focus_enum 순서, 선택). R9 CLASS_FOCUSES(사장님 결정 12의 "포커스")를 이름만 바꿨다(값·라벨·hint 그대로,
// 사장님 결정 16, DECISIONS R10-4). 서버 키는 weight_focus다
export const WEIGHT_FOCUSES = [
  { value: "power", label: "파워", hint: "가벼운 무게 · 빠른 속도" },
  { value: "strength", label: "스트렝스", hint: "무거운 무게 · 적은 반복" },
  { value: "hypertrophy", label: "근비대", hint: "중간 무게 · 많은 반복" },
  { value: "endurance", label: "근지구력", hint: "가벼운 무게 · 긴 세트" },
];

// 웨이트 포커스 칸 아래 안내. 사장님 결정 16의 앞 구간 설명 구절은 간결 총평(판 5)이 저장하지 않는 옛 상세 문장에만 있어, 회원 총평
// 문장에 나오지 않는다고 적는다(앱 전체 리뷰 1차, DECISIONS 결정 기록). 일간 판 6도 이름은 쓰지 않고, 웨이트 포커스가 있는 날의
// 가벼운 운동형·기초 지구력형을 근력 위주 문장으로 바꾸는 데만 쓴다(DECISIONS DS6-1)
export const WEIGHT_FOCUS_HINT =
  "코어·스트렝스 구간의 성격이에요. 회원 총평 문장에는 나오지 않아요. 출력이 있는 월요일처럼 웨이트 구간이 없으면 비워 두세요.";

// 수업 추가 창의 정원 기본값(월간 시간표 JSON의 값)과 입력 범위
export const CLASS_CAPACITY_DEFAULT = 12;
export const CLASS_CAPACITY_MAX = 100;

function findType(value) {
  return (
    CLASS_TYPES.find((t) => t.value === value) ||
    LEGACY_CLASS_TYPES.find((t) => t.value === value) ||
    null
  );
}

// 새 수업에 고를 수 있는 타입인가(9개)
export function isCreatableClassType(value) {
  return CLASS_TYPES.some((t) => t.value === value);
}

// 횟수권에서 1회를 차감하지 않는 수업 타입(2026-10-24 사장님 결정 A, 서버 models.CreditFreeClassTypes와 같은 목록).
// 회원 예약·일괄 예약·관리자 인원 추가·게스트 기록 이관 모두 차감하지 않는다. 쓸 수 있는 회원권은 정규 수업처럼 필요하다(서버가 본다)
export const CREDIT_FREE_CLASS_TYPES = ["hyrox", "running", "other"];

// 그 타입 수업 예약이 횟수권을 차감하지 않는가. 수업·기록에 저장된 타입 그대로 본다(effectiveClassType을 쓰지 않음): 예전 타입
// (Cardio) 수업은 제목이 "Running"이어도 정규 수업이라 차감한다(서버 models.IsCreditFreeClassType과 같은 판정).
// 취소 때 돌려줄지는 타입이 아니라 서버의 예약 행(credit_deducted)이 정한다(배포 전에 차감한 Running 예약은 취소하면 돌려준다)
export function isCreditFreeClassType(value) {
  return CREDIT_FREE_CLASS_TYPES.includes(value);
}

// ---------- 기타(other) 수업 이름(2026-10-24 사장님 결정 B) ----------
// 서버 request.ValidateOtherClassTitle과 같은 규칙: 앞뒤 공백을 빼고, 비면 "기타", 20자(코드 포인트)까지, 줄바꿈·탭·제어 문자·
// 연이은 공백·**·==가 없고(서버 commentary.PlainText가 바꾸는 글자), 다른 타입의 표시 이름(대소문자 무시)이 아니다.
// 이름은 기타 수업에만 쓴다. 다른 타입은 서버가 title을 무시하고 타입 표시 이름을 넣는다.
// 수업에 예약(취소 포함)이나 운동 기록이 생기면 수정이 막히므로(409) 이름도 첫 예약 전에만 바꾼다
export const OTHER_CLASS_TITLE_MAX = 20;
// 이름 칸의 HTML maxlength. maxlength는 UTF-16 단위로 세어 이모지 같은 글자(코드 포인트 하나 = UTF-16 두 단위)를 두 자로 본다.
// 20자(코드 포인트)는 많아야 UTF-16 40단위이므로 칸은 40에서 막고, 20자 규칙은 validateOtherClassTitle이 본다(서버와 같은 수).
export const OTHER_CLASS_TITLE_INPUT_MAX = 2 * OTHER_CLASS_TITLE_MAX;
export const OTHER_CLASS_DEFAULT_TITLE = "기타";
export const OTHER_TITLE_ERRORS = {
  length: `이름은 ${OTHER_CLASS_TITLE_MAX}자까지 쓸 수 있어요.`,
  text: "이름에는 줄바꿈·탭·제어 문자·연이은 공백·**·==를 쓸 수 없어요.",
  label: "다른 수업 타입 이름(Running 등)은 기타 수업 이름으로 쓸 수 없어요.",
};

// Go unicode.IsSpace와 같은 공백(서버 strings.TrimSpace·strings.Fields 기준). JS \s와 달리 U+0085는 넣고 U+FEFF는 뺀다
function isGoSpace(code) {
  return (
    (code >= 0x09 && code <= 0x0d) ||
    code === 0x20 ||
    code === 0x85 ||
    code === 0xa0 ||
    code === 0x1680 ||
    (code >= 0x2000 && code <= 0x200a) ||
    code === 0x2028 ||
    code === 0x2029 ||
    code === 0x202f ||
    code === 0x205f ||
    code === 0x3000
  );
}

// 앞뒤 공백을 뺀 이름(서버 strings.TrimSpace). 문자열이 아니면 ""
export function trimClassTitle(value) {
  if (typeof value !== "string") return "";
  const chars = [...value];
  let start = 0;
  let end = chars.length;
  while (start < end && isGoSpace(chars[start].codePointAt(0))) start++;
  while (end > start && isGoSpace(chars[end - 1].codePointAt(0))) end--;
  return chars.slice(start, end).join("");
}

// 대소문자를 무시한 비교용 글자(서버 strings.EqualFold. 소문자로 바꾼 뒤 대문자로 바꿔 ſ·K(켈빈 기호) 같은 글자도 맞춘다)
function foldCase(s) {
  return s.toLowerCase().toUpperCase();
}

// 기타 수업 이름 검사. { ok, title: 저장될 이름(비면 "기타"), error: 문구(통과면 "") }
export function validateOtherClassTitle(value) {
  const t = trimClassTitle(value);
  if (!t) return { ok: true, title: OTHER_CLASS_DEFAULT_TITLE, error: "" };
  const chars = [...t];
  if (chars.length > OTHER_CLASS_TITLE_MAX) {
    return { ok: false, title: "", error: OTHER_TITLE_ERRORS.length };
  }
  const badChar = chars.some((ch) => {
    const code = ch.codePointAt(0);
    const control = code <= 0x1f || (code >= 0x7f && code <= 0x9f); // unicode.IsControl
    return control || (code !== 0x20 && isGoSpace(code));
  });
  if (badChar || t.includes("  ") || t.includes("**") || t.includes("==")) {
    return { ok: false, title: "", error: OTHER_TITLE_ERRORS.text };
  }
  const folded = foldCase(t);
  const clash = [...CLASS_TYPES, ...LEGACY_CLASS_TYPES].some(
    (type) => type.value !== "other" && foldCase(type.label) === folded
  );
  if (clash) return { ok: false, title: "", error: OTHER_TITLE_ERRORS.label };
  return { ok: true, title: t, error: "" };
}

// 화면에 보일 수업 이름: 기타 수업이고 이름(title)이 있으면 그 이름(공백 묶음은 하나로), 아니면 타입 표시 이름(itemTypeLabel).
// 다른 타입은 title을 쓰지 않는다(예전 D22 수업 제목 '카디오 클래스' 같은 글자가 바뀌어 보이지 않게)
export function classDisplayName(item) {
  if (!item || typeof item !== "object") return "";
  if (item.type === "other" && typeof item.title === "string") {
    const name = item.title.trim().split(/\s+/).join(" ");
    if (name) return name;
  }
  return itemTypeLabel(item);
}

// 수업이 쓰는 운동 프로그램 타입(서버 models.EffectiveClassType과 같은 규칙, DECISIONS R9-6). 예전 타입인데 제목이
// 새 타입 표시 이름(앞뒤 공백·대소문자 무시)이면 그 새 타입, 아니면 value 그대로. D22 이후 운영 수업(type Cardio +
// 요일 이름 제목)의 "운동 프로그램 →" 링크가 그 날짜의 새 타입 프로그램을 연다
export function effectiveClassType(value, title) {
  const raw = value == null ? "" : String(value);
  if (!LEGACY_CLASS_TYPES.some((t) => t.value === raw)) return raw;
  const name = typeof title === "string" ? title.trim().toLowerCase() : "";
  if (!name) return raw;
  const hit = CLASS_TYPES.find((t) => t.label.toLowerCase() === name);
  return hit ? hit.value : raw;
}

// 타입 표시명. 서버가 type_label(typeLabel)을 주면 그 값을 먼저 쓰고, 없으면 표, 표에 없으면 값 그대로
export function classTypeLabel(value, serverLabel) {
  if (typeof serverLabel === "string" && serverLabel.trim()) {
    return serverLabel.trim();
  }
  const t = findType(value);
  if (t) return t.label;
  return value == null ? "" : String(value);
}

// 응답 항목(수업·기록)의 표시명: type_label → typeLabel → 표
export function itemTypeLabel(item) {
  if (!item || typeof item !== "object") return "";
  return classTypeLabel(item.type, item.type_label || item.typeLabel);
}

// 목록 색 클래스(hyb·core·car). 모르는 값은 car(예전 화면과 같다)
export function classTypeTone(value) {
  const t = findType(value);
  return t ? t.tone : "car";
}

// 아이콘 파일 이름(src/assets/icons/{name}.png). 모르는 값은 cardio
export function classTypeIcon(value) {
  const t = findType(value);
  return t ? t.icon : "cardio";
}

function findIn(table, value) {
  return table.find((f) => f.value === value) || null;
}

// 카디오 포커스 값인가(대소문자 구분, ""은 아님)
export function isCardioFocus(value) {
  return !!findIn(CARDIO_FOCUSES, value);
}

// 카디오 포커스 표시 이름("무산소 역치"). 모르는 값이면 ""
export function cardioFocusLabel(value) {
  const f = findIn(CARDIO_FOCUSES, value);
  return f ? f.label : "";
}

// 카디오 포커스 선택 상자의 항목 이름. "무산소 역치 · 쉬지 않고 6분 넘게 이어 감"
export function cardioFocusOptionLabel(value) {
  const f = findIn(CARDIO_FOCUSES, value);
  return f ? `${f.label} · ${f.hint}` : "";
}

// 웨이트 포커스 값인가
export function isWeightFocus(value) {
  return !!findIn(WEIGHT_FOCUSES, value);
}

// 웨이트 포커스 표시 이름("근지구력"). 모르는 값이면 ""
export function weightFocusLabel(value) {
  const f = findIn(WEIGHT_FOCUSES, value);
  return f ? f.label : "";
}

// 웨이트 포커스 선택 상자의 항목 이름. "스트렝스 · 무거운 무게 · 적은 반복"
export function weightFocusOptionLabel(value) {
  const f = findIn(WEIGHT_FOCUSES, value);
  return f ? `${f.label} · ${f.hint}` : "";
}

// "YYYY-MM-DD"가 실제 날짜인가(브라우저 시간대와 무관하게 날짜 그대로 본다)
export function isYmd(value) {
  const match = YMD_RE.exec(String(value || ""));
  if (!match) return false;
  const y = Number(match[1]);
  const m = Number(match[2]);
  const d = Number(match[3]);
  const date = new Date(Date.UTC(y, m - 1, d));
  return date.getUTCMonth() === m - 1 && date.getUTCDate() === d;
}

// "06:30" · "06:30:00" · "6:30" → "06:30". 시각이 아니면 ""
export function hhmm(value) {
  const match = HHMM_RE.exec(String(value || "").trim());
  if (!match) return "";
  const h = Number(match[1]);
  const m = Number(match[2]);
  if (h > 23 || m > 59) return "";
  return `${String(h).padStart(2, "0")}:${match[2]}`;
}

function minutesOf(value) {
  const t = hhmm(value);
  if (!t) return -1;
  return Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));
}

// 시작 시각 + 분 → "HH:MM". 자정을 넘기거나 시각이 아니면 ""(종료 시각을 미리 채우지 않는다)
export function addMinutesHhmm(value, minutes) {
  const start = minutesOf(value);
  if (start < 0) return "";
  const end = start + minutes;
  if (end >= 24 * 60) return "";
  return `${String(Math.floor(end / 60)).padStart(2, "0")}:${String(
    end % 60
  ).padStart(2, "0")}`;
}

// 스케줄 항목마다 그 수업 날짜("YYYY-MM-DD")를 붙인 새 배열. 관리자 스케줄 응답(GET /v1/admin/classes/schedule?date=)의
// 항목에는 날짜가 없어서 요청한 날짜를 붙여 둔다. 수정 창은 이 날짜로 채운다(탭을 누른 뒤 새 목록이 오기 전에 남아 있던
// 다른 날짜 줄을 고를 수 있어서 그 순간의 날짜 탭을 쓰지 않는다). 항목에 이미 날짜 형식의 date가 있으면 그대로 둔다.
// 객체가 아닌 항목은 그대로 둔다. 원래 항목은 바꾸지 않는다
export function withClassDate(classes, date) {
  if (!Array.isArray(classes)) return [];
  const ymd = YMD_RE.test(String(date || "")) ? String(date) : "";
  return classes.map((c) =>
    c && typeof c === "object" && !Array.isArray(c)
      ? { ...c, date: YMD_RE.test(String(c.date || "")) ? c.date : ymd }
      : c
  );
}

// 고른 수업의 새 스케줄 줄: date 날짜의 스케줄 항목(classes)에서 고른 수업과 같은 ID 줄을 날짜를 붙여 돌려준다(없으면 null).
// 수업관리 패널에서 인원을 바꾼 뒤 다른 요일 탭을 보고 있어도 머리 인원("1 / 12명")을 그 수업 날짜의 스케줄로 새로 쓴다
// (R10 합치기, STATUS "R9 리뷰에서 열린 것")
export function freshClassOf(selected, classes, date) {
  if (!selected || typeof selected !== "object" || !selected.id) return null;
  return (
    withClassDate(classes, date).find(
      (c) => c && typeof c === "object" && c.id === selected.id
    ) || null
  );
}

// 수업 추가 창을 열 때의 폼. date = 지금 고른 날짜 탭. 타입은 비워 두고 직접 고른다. title = 기타 수업 이름(기타일 때만 보내고 쓴다)
export function emptyClassForm(date) {
  return {
    classId: "",
    date: isYmd(date) ? String(date) : "",
    type: "",
    legacyType: "",
    title: "",
    startTime: "",
    endTime: "",
    capacity: CLASS_CAPACITY_DEFAULT,
  };
}

// 수정 창의 이름 칸에 미리 넣을 값: 기타 수업이고 이름이 비지 않았으며 "기타"(이름을 비운 기타 수업)와 다를 때만 그 이름(앞뒤 공백 뺌).
// 다른 타입 수업의 제목(타입 표시 이름 'Hyrox', 예전 D22 제목 '카디오 클래스')은 넣지 않는다
function prefillClassTitle(c) {
  if (c.type !== "other") return "";
  const t = trimClassTitle(c.title);
  return t && t !== OTHER_CLASS_DEFAULT_TITLE ? t : "";
}

// 수업 수정 창을 열 때의 폼. cls = 스케줄 항목({ id, date, type, title, time:"06:30:00", end_time:"07:30", capacity }).
// 예전 타입 수업이면 type은 비우고 legacyType에 남긴다(새 9개 중에서 골라야 저장된다)
export function classFormFromClass(cls) {
  const c = cls && typeof cls === "object" ? cls : {};
  const creatable = isCreatableClassType(c.type);
  const cap = Number(c.capacity);
  return {
    classId: c.id ? String(c.id) : "",
    date: isYmd(c.date) ? String(c.date) : "",
    type: creatable ? c.type : "",
    legacyType: !creatable && c.type ? String(c.type) : "",
    title: prefillClassTitle(c),
    startTime: hhmm(c.time || c.start_time),
    endTime: hhmm(c.end_time),
    capacity: Number.isInteger(cap) && cap > 0 ? cap : CLASS_CAPACITY_DEFAULT,
  };
}

// 폼 검사. { ok, errors: { date?, type?, title?, startTime?, endTime?, capacity? }, message: 첫 오류 문구 }.
// 이름(title)은 기타 수업일 때만 본다(validateOtherClassTitle, 서버와 같은 규칙). 다른 타입이면 남아 있는 이름 값은 보지도 보내지도 않는다
export function validateClassForm(form) {
  const f = form && typeof form === "object" ? form : {};
  const errors = {};
  if (!isYmd(f.date)) errors.date = "날짜를 골라 주세요.";
  if (!isCreatableClassType(f.type)) errors.type = "타입을 골라 주세요.";
  if (f.type === "other") {
    const name = validateOtherClassTitle(f.title);
    if (!name.ok) errors.title = name.error;
  }
  const start = minutesOf(f.startTime);
  const end = minutesOf(f.endTime);
  if (start < 0) errors.startTime = "시작 시각을 입력해 주세요.";
  if (end < 0) errors.endTime = "종료 시각을 입력해 주세요.";
  else if (start >= 0 && end <= start) {
    errors.endTime = "종료 시각은 시작 시각보다 늦어야 해요.";
  }
  const cap = Number(f.capacity);
  if (
    f.capacity === "" ||
    f.capacity == null ||
    !Number.isInteger(cap) ||
    cap < 1 ||
    cap > CLASS_CAPACITY_MAX
  ) {
    errors.capacity = `정원은 1~${CLASS_CAPACITY_MAX}명 사이 숫자로 입력해 주세요.`;
  }
  const order = ["date", "type", "title", "startTime", "endTime", "capacity"];
  const first = order.find((k) => errors[k]);
  return { ok: !first, errors, message: first ? errors[first] : "" };
}

// POST /v1/admin/classes · PUT /v1/admin/classes/{class_id} 본문. title은 기타(other)일 때만 넣는다(앞뒤 공백 뺌, 비면 ""이고 서버가
// "기타"로 채운다). 다른 타입은 title 키가 없다(서버가 타입 표시 이름을 넣는다. 기타를 다른 타입으로 고치면 이름도 그 표시 이름이 된다)
export function classRequestBody(form) {
  const f = form && typeof form === "object" ? form : {};
  const type = String(f.type || "");
  return {
    date: String(f.date || ""),
    type,
    ...(type === "other" ? { title: trimClassTitle(f.title) } : {}),
    start_time: hhmm(f.startTime),
    end_time: hhmm(f.endTime),
    capacity: Number(f.capacity),
  };
}

// 바뀐 것을 비교할 본문: 기타 이름 ""과 "기타"는 서버에 같은 이름("기타")으로 저장되므로 같게 본다
function comparableClassBody(form) {
  const body = classRequestBody(form);
  if (body.title === OTHER_CLASS_DEFAULT_TITLE) body.title = "";
  return body;
}

// 수정 창에서 바뀐 것이 있는가(없으면 저장 버튼을 끈다). 기타 수업은 이름만 고쳐도 바뀐 것이다
export function hasClassFormChanges(cls, form) {
  const before = comparableClassBody(classFormFromClass(cls));
  const after = comparableClassBody(form);
  const keys = new Set([...Object.keys(before), ...Object.keys(after)]);
  return [...keys].some((k) => before[k] !== after[k]);
}

// 고른 수업을 고치거나 지울 수 있는가.
//   bookings = GET /v1/admin/classes/{class_id}/bookings 목록(확정 예약만. 취소한 예약은 들어 있지 않다),
//   bookingsLoaded = 그 목록(과 예약 행 유무)을 받았는가,
//   hasWorkouts = GET /v1/admin/classes/{class_id}/workouts/exists 결과(true | false | null 모름),
//   hasBookingRows = GET /v1/admin/classes/{class_id}/bookings/exists 결과(취소 포함 예약 행이 있는가, true | false | null 모름)
// 서버는 취소한 예약도 예약으로 센다(409 CLASS_HAS_BOOKINGS 기준 "예약 행이 하나라도 있으면", DECISIONS R9-5). 예약자 목록은 확정 예약만
// 주므로 예약이 모두 취소된 수업은 목록이 비어도 hasBookingRows가 true다: 그때도 둘 다 끄고 이유를 보인다(R9 리뷰 1차).
// 목록을 받은 뒤에는 cls.booked(수업을 고를 때 받은 스케줄 줄의 확정 인원)를 보지 않고 새로 받은 목록과 예약 행 유무로만 정한다:
// 패널에서 마지막 확정 예약을 취소하면 목록은 비고 예약 행은 남는데, 고른 줄의 인원은 그때 값(1) 그대로라 "예약이 있는 수업은"이
// 남았다(R9 리뷰 2차). 목록을 받기 전(또는 받지 못함)에는 둘 다 끄고, 스케줄 인원이 있으면 그 이유를 미리 보인다.
// 운동 기록이 있으면 둘 다 끈다(서버가 수정·삭제 모두 409 CLASS_HAS_WORKOUTS).
// 예약 행·운동 기록 유무를 모르면(조회 실패) 켜 두고 서버 거절을 보여 준다.
// { editable, deletable, reason }
export const CLASS_LOCK_BOOKED = "예약이 있는 수업은 수정·삭제할 수 없어요.";
export const CLASS_LOCK_CANCELLED =
  "취소된 예약 기록이 있는 수업은 수정·삭제할 수 없어요.";
export const CLASS_LOCK_WORKOUTS =
  "운동 기록이 있는 수업은 수정·삭제할 수 없어요.";
export function classLock(
  cls,
  bookings,
  bookingsLoaded,
  hasWorkouts,
  hasBookingRows
) {
  if (!cls) return { editable: false, deletable: false, reason: "" };
  if (!bookingsLoaded) {
    const reason = Number(cls.booked) > 0 ? CLASS_LOCK_BOOKED : "";
    return { editable: false, deletable: false, reason };
  }
  const list = Array.isArray(bookings) ? bookings : [];
  if (list.length > 0) {
    return { editable: false, deletable: false, reason: CLASS_LOCK_BOOKED };
  }
  if (hasBookingRows === true) {
    return { editable: false, deletable: false, reason: CLASS_LOCK_CANCELLED };
  }
  if (hasWorkouts === true) {
    return { editable: false, deletable: false, reason: CLASS_LOCK_WORKOUTS };
  }
  return { editable: true, deletable: true, reason: "" };
}

// ---------- 수업관리 날짜 탭(주) ----------
// 오늘이 든 주(월~일)를 "이번 주"(0주)로 센다. 일요일도 그 주의 마지막 날이라, 일요일에 열면 오늘이 든 주(앞 월요일~오늘)가 이번 주다
// (R9 리뷰 1차: R9가 일요일 수업과 일요일 탭을 열었는데 예전처럼 일요일에 다음 주를 "이번 주"로 보여 오늘 수업이 "지난 주"에만 보였다).
// 운동 프로그램 탭(dailyPrograms.weekDates)·실시간 심박(buildDays)과 같은 주다.

const DAY_MS = 24 * 60 * 60 * 1000;

// 그 날짜가 든 주의 월요일(로컬 자정). 날짜가 아니면 null
export function mondayOf(date) {
  const d = date instanceof Date ? date : new Date(NaN);
  if (Number.isNaN(d.getTime())) return null;
  const mon = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  mon.setDate(mon.getDate() - ((mon.getDay() + 6) % 7));
  return mon;
}

// today가 든 주를 0주로, offset주 뒤의 월~일 7일(Date, 로컬 자정)
export function weekDays(today, offset = 0) {
  const mon = mondayOf(today);
  if (!mon) return [];
  mon.setDate(mon.getDate() + (Number(offset) || 0) * 7);
  return Array.from({ length: 7 }, (_, i) => {
    const dt = new Date(mon);
    dt.setDate(mon.getDate() + i);
    return dt;
  });
}

// target 날짜가 든 주가 today가 든 주에서 몇 주 떨어졌는가(앞이면 음수). 날짜가 아니면 null
export function weekOffsetOf(today, target) {
  const a = mondayOf(today);
  const b = mondayOf(target);
  if (!a || !b) return null;
  return Math.round((b - a) / (7 * DAY_MS));
}

// ---------- 날짜 닫기 확인 창(CAR-130, 2026-10-24 기본값 D2) ----------
// 수업관리 [이 날짜 수업 닫기] 확인 창에 보일 그 날짜 수업 줄. classes = 관리자 스케줄 항목(서버가 시각순으로 준 순서 그대로).
// { id, time: "06:30", name: 화면 이름(classDisplayName, 기타는 수업 이름), booked: 확정 예약 인원(0 이상 정수), text: "06:30 Pull & Cardio" }.
// 객체가 아닌 항목은 뺀다. 확정 예약이 있는 수업은 서버가 지우지 않으므로(409) 창이 그 수업을 미리 알린다
export function closeDateClassLines(classes) {
  if (!Array.isArray(classes)) return [];
  return classes
    .filter((c) => c && typeof c === "object" && !Array.isArray(c))
    .map((c, i) => {
      const time = hhmm(c.time || c.start_time);
      const name = classDisplayName(c);
      const n = Number(c.booked);
      return {
        id: c.id ? String(c.id) : `row-${i}`,
        time,
        name,
        booked: Number.isInteger(n) && n > 0 ? n : 0,
        text: [time, name].filter(Boolean).join(" "),
      };
    });
}

// ---------- 무료체험 신청 편집 창의 예정 시간(CAR-130) ----------
// 고른 날짜의 실제 수업(관리자 스케줄 항목, GET /v1/admin/classes/schedule?date=)으로 시간 선택지를 만든다. 일요일도 수업이 있으면 고른다.
// value = 시작 시각 "HH:MM"(공개 신청 폼이 preferred_times에 넣는 꼴, current와 같은 시각이면 아래처럼 current 글자), label = "06:30 · Pull & Cardio"(같은 시각 수업이 둘 이상이면
// 이름을 " / "로 잇고, 그 시각 수업이 모두 정원이 찼으면 끝에 " · 마감"). 시각 순.
// current(지금 고른 값)는 글자가 아니라 시각 키(hhmm)로 선택지와 맞춘다. 수업관리 [무료체험]으로 만든 신청은 서버가 수업의
// start_time::text("19:30:00")를 preferred_times에 넣고, 공개 신청 폼은 "19:30"을 넣는다. 그 시각 수업이 있으면 그 선택지 하나만
// 두고(이름 글자 그대로) value만 current 원래 글자로 바꾼다: 그대로 저장하면 preferred_times가 바뀌지 않는다(편집 창은 바뀐 칸만 보낸다).
// 그 날짜에 그 시각(HH:MM) 수업이 없을 때만 current를 그대로 더해 계속 보이고 고를 수 있게 한다("· 이 날짜 수업에 없는 시각".
// 시간표가 바뀌었거나 예전 고정 목록의 07:30처럼 실제 수업과 다른 값을 열기만 해도 지우지 않게)
export const CLASS_TIME_MISSING_NOTE = "이 날짜 수업에 없는 시각";
export function classTimeOptions(classes, current) {
  const byTime = new Map();
  for (const c of Array.isArray(classes) ? classes : []) {
    if (!c || typeof c !== "object" || Array.isArray(c)) continue;
    const t = hhmm(c.time || c.start_time);
    if (!t) continue;
    const slot = byTime.get(t) || { names: [], full: true };
    const name = classDisplayName(c);
    if (name && !slot.names.includes(name)) slot.names.push(name);
    const booked = Number(c.booked);
    const cap = Number(c.capacity);
    const full =
      c.status === "close" ||
      (Number.isFinite(booked) && cap > 0 && booked >= cap);
    slot.full = slot.full && full;
    byTime.set(t, slot);
  }
  const options = [...byTime.entries()].map(([value, slot]) => ({
    value,
    label: [value, slot.names.join(" / "), slot.full ? "마감" : ""]
      .filter(Boolean)
      .join(" · "),
  }));
  const cur = typeof current === "string" ? current : "";
  const curKey = hhmm(cur);
  const hit = curKey ? options.find((o) => o.value === curKey) : null;
  if (hit) {
    hit.value = cur; // 같은 시각 선택지는 byTime 때문에 하나뿐이다
  } else if (cur) {
    options.push({ value: cur, label: `${cur} · ${CLASS_TIME_MISSING_NOTE}` });
  }
  const key = (o) => hhmm(o.value) || o.value;
  return options.sort((a, b) =>
    key(a) < key(b) ? -1 : key(a) > key(b) ? 1 : 0
  );
}
